import { ExtraOptions } from '@angular/router';
import { SpecifyTeamComponent } from './modules/core/specify-team/specify-team.component';
import { AuthenticationGuard } from './modules/core/guards/authentication-guard';
import { TeamValidationGuard } from './modules/core/guards/team-validation-guard';
import { NotFoundComponent } from './modules/core/components/not-found/not-found.component';
const ɵ0 = () => import("./modules/auth-module/auth.module.ngfactory").then(m => m.AuthModuleNgFactory), ɵ1 = () => import("./modules/public/public.module.ngfactory").then(m => m.PublicModuleNgFactory), ɵ2 = () => import("./modules/main-module/main.module.ngfactory").then(m => m.MainModuleNgFactory), ɵ3 = () => import("./modules/auth0-linking-module/auth0-linking.module.ngfactory").then(m => m.Auth0LinkingModuleNgFactory);
const routes = [
    {
        path: '',
        component: SpecifyTeamComponent
    },
    {
        path: '404',
        component: NotFoundComponent
    },
    {
        path: ':team',
        canActivate: [TeamValidationGuard],
        loadChildren: ɵ0,
    },
    {
        path: ':team/tickets',
        canActivate: [TeamValidationGuard],
        loadChildren: ɵ1,
    },
    {
        path: ':team/main',
        canLoad: [AuthenticationGuard],
        canActivate: [TeamValidationGuard],
        loadChildren: ɵ2,
    },
    {
        path: ':team/auth0-link',
        canActivate: [TeamValidationGuard],
        loadChildren: ɵ3,
    }
];
const routesConfiguration = {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    enableTracing: false,
    paramsInheritanceStrategy: 'always'
};
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
